var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"selected-item-primary"},[_c('span',[_vm._v(_vm._s(_vm.item.label))]),_c('span',{staticClass:"delete-search-item",on:{"click":function($event){return _vm.deleteItem(_vm.item.id)}}},[_vm._v("×")])])}
var staticRenderFns = []

export { render, staticRenderFns }